import { render, staticRenderFns } from "./storage_location.vue?vue&type=template&id=2131dee7"
import script from "./storage_location.vue?vue&type=script&lang=js"
export * from "./storage_location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports